import React from 'react';
import { NavLink } from 'react-router-dom';
import './header.css';

export default function Header() {

  return (
    <header className="header-container">
      <div className="background"/>
      <div className="background-gradient"/>
      <div className="header-content">
        <nav>
          <NavLink exact to="/" className="title">
            <div className="sub-title">RPMP Request For Information</div>
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
